import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import "./index.css";

import { TempoDevtools } from "tempo-devtools";
import { setupGlobalErrorHandling } from "./lib/errorLogging";

// Get base URL for routing
const basename = import.meta.env.BASE_URL;

// Get root element
const container = document.getElementById("root");

if (!container) {
  throw new Error(
    "Root element not found - The application requires a <div id='root'></div> element in index.html",
  );
}

// Create root and render app
const root = createRoot(container);

// Initialize Tempo and error handling without top-level await
const initializeApp = () => {
  Promise.resolve().then(() => {
    try {
      // Make sure we're handling the return type correctly
      const initPromise = TempoDevtools.init();

      // Check if init returns a promise, if so use it, otherwise create a resolved promise
      (typeof initPromise === "object" &&
      initPromise !== null &&
      initPromise &&
      "then" in initPromise
        ? initPromise
        : Promise.resolve()
      )
        .then(() => {
          setupGlobalErrorHandling();
        })
        .catch((error) => {
          console.error("Failed to initialize Tempo:", error);
        });
    } catch (error) {
      console.error("Failed to initialize:", error);
    }
  });
};

initializeApp();

root.render(
  <StrictMode>
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);
